import Drawer from 'components/drawer/Drawer';
import modulesMap from 'core/modulesMap';
import { bindMethod } from 'helpers/bind';
import { map } from 'lodash-es';
import { forceArray } from 'navigation/component/Component';
import store from 'store';
import mqStore from 'store/mqStore';
export default class Filters extends Drawer {
    filterUrl = this.el.getAttribute('data-filter-url');
    checked = {};
    eventsChecked = {};
    constructor(el, options) {
        super(el, options);
        this.name = 'filters';
        this.params = {
            desktop: {
                axis: 'X',
                direction: 'reversed'
            },
            mobile: {
                axis: 'X',
                direction: 'reversed'
            }
        };
        this.initializeFilters();
    }
    initialized() {
        super.initialized();
    }
    getModulesMap() {
        return {
            ...modulesMap
        };
    }
    bindEvents(add) {
        const method = bindMethod(add);
        if (this.refs.filterItems)
            this.refs.filterItems.forEach(el => el[method]('change', this.onFilterUpdate));
        this.refs.filterSubmit.forEach(submit => submit[method]('click', () => this.submit()));
        this.refs.filterReset.forEach(reset => reset[method]('click', this.reset));
        super.bindEvents(add);
    }
    initializeFilters() {
        if (this.refs.filterCheckboxes === undefined)
            return;
        if (mqStore.tabletPortrait.get()) {
            forceArray(this.refs.filterCheckboxes).forEach((checkbox) => {
                checkbox.checked = false;
            });
        }
        else {
            forceArray(this.refs.filterCheckboxes).forEach((checkbox) => {
                checkbox.checked = true;
            });
        }
    }
    reset = () => {
        this.refs.filterItems.forEach((checkbox) => {
            checkbox.checked = false;
        });
        this.parseFilters();
        this.submit();
    };
    parseFilters() {
        const checked = {};
        const eventsChecked = {};
        let empty = true;
        this.refs.filterItems.forEach((checkbox) => {
            if (!checkbox.checked)
                return;
            if (!checked[checkbox.name])
                checked[checkbox.name] = [];
            if (!eventsChecked[checkbox.name])
                eventsChecked[checkbox.name] = [];
            checked[checkbox.name].push(checkbox.value);
            eventsChecked[checkbox.name].push(checkbox.dataset.eventLabel);
            empty = false;
        });
        this.checked = checked;
        this.eventsChecked = eventsChecked;
        this.refs.filterReset.forEach(reset => reset[empty ? 'setAttribute' : 'removeAttribute']('disabled', 'true'));
        const separator = ~this.filterUrl.indexOf('?') ? '&' : '?';
        const url = this.filterUrl + (empty ? '' : (separator + map(checked, (values, key) => `${key}=${values.join(',')}`).join('&')));
        this.refs.filterSubmit.forEach(submit => submit.setAttribute('href', url));
        this.sendEvent();
    }
    onFilterUpdate = ({ currentTarget: checkbox }) => {
        if (checkbox.checked && checkbox.getAttribute('data-exclude') === 'true') {
            this.refs.filterItems.forEach((_checkbox) => {
                if (_checkbox.name === checkbox.name && checkbox.value !== _checkbox.value)
                    _checkbox.checked = false;
            });
        }
        this.parseFilters();
    };
    submit() {
        this.parseFilters();
        store.drawer.set(null);
    }
    sendEvent = () => {
        const data = {
            event: 'click_filter'
        };
        for (const key in this.eventsChecked)
            data[key] = this.eventsChecked[key].join('::');
        if (window.dataLayer)
            window.dataLayer.push(data);
    };
    resize() {
        super.resize();
        this.initializeFilters();
    }
}
